class FooterElem extends HTMLElement {
    static get observedAttributes() {
        return ["floating"];
    }

    constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    connectedCallback() {
        if(window.location.hash.includes("no_chrome")) {
            document.body.classList.add("no_chrome");
        }
        this.render();
    }

    get floating() {
        return this.hasAttribute("floating");
    }

    render() {
        const currentYear = new Date().getFullYear();

        this.shadowRoot.innerHTML = `
            <style>
              :host {
                display: block;
              }

              * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
              }

              footer {
                margin-top: 5.5rem;
                position: relative;
                background: var(--shaded-background-color);
                padding: 4.5rem 2.7rem;
              }

              :host([floating]) footer {
                margin-top: 0;
              }

              .footer-container {
                max-width: 1100px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
              }

              footer::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 1px;
                background: linear-gradient(90deg, transparent, rgba(0,0,0,0.1), transparent);
              }

              :host([floating]) footer::before {
                display: none;
              }

              .copyright {
                font-family: "Lato", sans-serif;
                font-size: 1.6rem;
                color: #666;
              }

              nav {
                display: flex;
                gap: 2.7rem;
              }

              nav a {
                font-family: "Lato", sans-serif;
                font-size: 1.6rem;
                color: var(--action-color);
                text-decoration: none;
                transition: color 0.2s ease;
              }

              @media (max-width: 600px) {
                .footer-container {
                  flex-direction: column;
                  gap: 1.8rem;
                  text-align: center;
                }

                nav {
                  flex-direction: column;
                  gap: 1.35rem;
                }
              }
            </style>

            <footer>
              <div class="footer-container">
                <span class="copyright">© ${currentYear} Acme Weather Corporation, LLC</span>
                <nav>
                  <a href="/privacy">Privacy Policy</a>
                  <a href="/terms">Terms of Use</a>
                  <a href="/datasources">Data Sources</a>
                </nav>
              </div>
            </footer>
        `;
    }
}

customElements.define("footer-elem", FooterElem);